import axios from "axios";
import * as urlList from "../../config";
import { getCookie } from "../../services/cookie";
import { showError } from "./errorActions";


export const getLegoStatus = async (monthId, brandCode, collectionValue, dispatch) => {
    try {
        const params = {
            monthId: monthId,
            brandCode: brandCode,
            collection: collectionValue,
        };

        const response = await axios.post(urlList.CHECK_LEGO_STATUS_URL, params, {
            headers: {
                "Content-Type": "application/json",
                xAuthLuxotticaToken: getCookie("xAuthLuxotticaToken"),
            },
        });

        return response.data;

    } catch (error) {
        const errorMessage =
            error.response?.data?.message ||
            error.message ||
            "Failed to fetch LEGO status";

        if (dispatch) {
            dispatch(showError(errorMessage));
        }
        console.error("Error fetching LEGO status:", errorMessage, error.response || error);
        throw error;
    }
};